
import { YouTubeChannel } from '@/components/dashboard/profiles/types';
import { YouTubeChannelListResponse } from './types';
export { replyToYouTubeComment } from './data/comment-replies';

// Récupérer les chaînes YouTube de l'utilisateur
export const fetchYouTubeChannels = async (accessToken: string): Promise<YouTubeChannel[]> => {
  try {
    console.log('Récupération des chaînes YouTube');
    const response = await fetch('https://www.googleapis.com/youtube/v3/channels?part=snippet,statistics&mine=true', {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      console.error('Erreur lors de la récupération des chaînes YouTube', errorData);
      throw new Error(`Erreur API YouTube: ${errorData.error?.message || 'Erreur inconnue'}`);
    }
    
    const data: YouTubeChannelListResponse = await response.json();
    console.log(`${data.items.length} chaînes YouTube trouvées`);
    
    return data.items.map(item => ({
      id: item.id,
      title: item.snippet.title,
      thumbnailUrl: item.snippet.thumbnails.medium?.url || item.snippet.thumbnails.default.url,
      description: item.snippet.description,
      subscriberCount: parseInt(item.statistics.subscriberCount, 10),
      videoCount: parseInt(item.statistics.videoCount, 10),
    }));
  } catch (error) {
    console.error('Exception lors de la récupération des chaînes YouTube', error);
    throw error;
  }
};

// YouTube comments fetching function - disabled
export const fetchYouTubeComments = async (
  accessToken: string, 
  maxResults = 100
): Promise<any[]> => {
  console.log('YouTube comment fetching has been disabled');
  return [];
};
